import React from "react";

export function PageHeader({ title, subtitle, actions, testid = "page-header" }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-6" data-testid={testid}>
      <div>
        <h1 className="text-2xl md:text-3xl font-semibold tracking-tight text-slate-900" data-testid="page-title">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

export function Section({ title, children, actions, className = "" }) {
  return (
    <section className={`bg-white border border-slate-200 rounded-lg shadow-sm ${className}`}>
      {(title || actions) && (
        <div className="flex items-center justify-between px-5 py-3 border-b border-slate-200">
          {title && <h2 className="text-sm font-semibold text-slate-700 uppercase tracking-wide">{title}</h2>}
          {actions}
        </div>
      )}
      <div>{children}</div>
    </section>
  );
}

export function EmptyState({ title, description, action, testid = "empty-state" }) {
  return (
    <div className="text-center py-14 px-6" data-testid={testid}>
      <div className="mx-auto w-12 h-12 rounded-full bg-slate-100 border border-slate-200 flex items-center justify-center text-slate-400 mb-3">
        —
      </div>
      <div className="text-slate-800 font-medium">{title}</div>
      {description && <div className="text-sm text-slate-500 mt-1 max-w-md mx-auto">{description}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
